// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pagination_pagination__v_uQ5","icon":"pagination_icon__JNSIt","inner":"pagination_inner__62iSu"};